import Box from "@mui/material/Box";
import { Skeleton } from "@mui/material";

type RectangularSkeleton = {
  height: string;
  width?: string;
  ariaLabel?: string;
};
export function RectangularSkeleton(props: RectangularSkeleton) {
  return (
    <Box
      role="presentation"
      style={{
        width: props.width ? props.width : "100%",
        height: props.height,
      }}
      aria-label={props.ariaLabel ? props.ariaLabel : "Loading"}
      aria-live={"polite"}
      aria-busy={true}
    >
      <Skeleton
        variant={"rectangular"}
        height={props.height}
        width={props.width}
      />
    </Box>
  );
}
